import type { Arealplan } from '@origo/arealplan';
import { useArealplaner } from '@origo/arealplan';

export interface UsePlanSearchReturn {
    allPlans: Arealplan[];
    loading: boolean;
    error: string | null;
}

/**
 * Hent alle arealplaner via fanout mot alle 16 plantyper. Tynt wrapper
 * rundt `useArealplaner()` fra `@origo/arealplan` som beholder eksisterende
 * navngivning (`allPlans`/`loading`/`error`) for at PlanSearch.tsx skal
 * holde seg uendret.
 */
export function usePlanSearch(): UsePlanSearchReturn {
    const query = useArealplaner();
    return {
        allPlans: query.data ?? [],
        loading: query.isLoading,
        error: query.error instanceof Error ? query.error.message : null,
    };
}
